import React from 'react';
import cx from 'classnames';

import LargeNumber from 'components/LargeNumber/LargeNumber';
import ScrambleNumber from 'components/ScrambleNumber/ScrambleNumber';

const ProfileMetric = ({ title, value, isCurrency = false, onClick }) => {
  let valueDisplay = value;

  if (isCurrency) {
    valueDisplay = (
      <>
        <LargeNumber isCurrency amount={value} />
      </>
    );
  } else {
    valueDisplay = <LargeNumber amount={value} />;
  }

  if (value === undefined) {
    valueDisplay = <ScrambleNumber />;
  }

  return (
    <div
      className={cx('profile-metric', { 'cursor-pointer': Boolean(onClick) })}
      onClick={onClick}
    >
      <div className="profile-metric-value">{valueDisplay}</div>
      <div className="profile-metric-title">{title}</div>
    </div>
  );
};

export default ProfileMetric;
